import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * tailwind-merge, told the names tailwind.config.js adds to the theme. A class it doesn't know is
 * kept beside the stock one it should replace (rounded-xl next to rounded-assistant), and
 * Tailwind's CSS order, not the order in cn(), picks the winner.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      radius: ["assistant"],
      shadow: ["card", "card-hover", "blue-glow", "lip"],
      ease: ["spring"],
      animate: [
        "accordion-down",
        "accordion-up",
        "page-in",
        "fade-in",
        "slide-in-right",
        "caret-blink",
        "shimmer",
        "ring-pulse",
        "caret-insert",
      ],
    },
    classGroups: {
      z: [{ z: ["scrim", "lip", "toast", "overlay", "drag"] }],
      duration: [{ duration: ["travel", "fade"] }],
      "max-w": [{ "max-w": ["thread"] }],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** "1 document", "3 documents". */
export function pluralize(count: number, singular: string, plural = `${singular}s`): string {
  return `${count} ${count === 1 ? singular : plural}`;
}
